import type { TPKState } from './types'
import { fetchTPKDuelData } from './actions'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import type { RootState } from '../reducers'
import { initialState } from './reducer'

export const useTPKState = (
    tpkToken: string,
    { autoload }: { autoload: boolean }
): TPKState => {
    const dispatch = useDispatch()

    const data: TPKState = useSelector((s: RootState) => s.tuPreferesKingState)

    useEffect(() => {
        if ((!data.duel || data.duel.tpkToken !== tpkToken) && autoload) {
            dispatch(fetchTPKDuelData(tpkToken))
        }
    }, [data.duel, tpkToken, autoload])

    if (data.duel && data.duel.tpkToken !== tpkToken) {
        return initialState
    }

    return data
}
